import React, {useState } from "react";
import { LoadingAnimation } from "./LoadingAnimation";
import { VillaTile } from "./VillaTile";
import LazyLoad from 'react-lazyload';


export const PopularVillas  = (props) => {
    const [count, setCount] = useState(props.count ? props.count : 6);
    const [data, setData] = useState(props.data);
    const [mobile, setMobile] = useState(props.mobile);
    const [tablet, setTable] = useState(props.tablet);

    var villas = [];
    let villaTiles = count;
    if(props.villaweek && villaTiles > 0 && data.accommodation_of_the_week) {
        data.accommodation_of_the_week['accommodation_of_the_week'] = true;
        villas.push(data.accommodation_of_the_week);
        villaTiles --;
    }

    if(props.villanew && villaTiles > 0 && data.new_online) {
        data.new_online['new_online'] = true;
        villas.push(data.new_online);
        villaTiles --;
    }

    if(props.villarecommended && villaTiles > 0 && data.recommended) {
        data.recommended['recommended'] = true;
        villas.push(data.recommended);
        villaTiles --;
    }

    if(data.top_accommodations && villaTiles > data.top_accommodations.length) {
        villaTiles = data.top_accommodations.length;
    }

    if(villaTiles > 0 && data.top_accommodations) {
        for(var i = 0; i < villaTiles; i++) {
            if(data.top_accommodations[i]) villas.push(data.top_accommodations[i]);
        }
    }
    let position = 0;
    const items = villas.map((item, key) => {
            position++;
            return <VillaTile
                key={item.id}
                id={item.id}
                position={position}
                data={item}
                gaEventType="home"
                className="mb-4"
                mobile={mobile}
                tablet={tablet}
                reviewType="stars"
                reviewStarText={true}
                vidFavButtonsPosition="name"
                currency={data.currency}
                slideshowImagesPreloadCount={props.slideshowImagesPreloadCount}
                slideshowImagesLazyloadNext={props.slideshowImagesLazyloadNext}
            />
        }
    );
    const villaItems = villas.map((item, key) => {
        return ({'name': item.name, 'villaUri': item.villaUri});
    });

    var components = [];
    const villaTileFlexStyle = {
        flex: mobile ? '0 0 100%' : '0 0 33.333333%',
        paddingBottom: '3em'
    };
    for(var i = 0; i < items.length; i++) {
        if(i >= (mobile ? 1 : 3)){
            components[i] = (
            <LazyLoad
            key={"lazyPopular_" + i}
            once={true}
            placeholder={<LoadingAnimation className="width-100" style={villaTileFlexStyle} />}>
                {items[i]}
            </LazyLoad>
            );
        } else {
            components[i] = items[i];
        }
    }

    return (
        <>
            <div className="flex flex-wrap width-100 z-index-0">{components}</div>
            <div className="flex justify-saround hide">{villaItems.map((item, index) => { return <a key={index} href={item.villaUri}>{item.name}</a>})}</div>
        </>
    )
}